import { render, staticRenderFns } from "./Identite.vue?vue&type=template&id=4ddd69ac&scoped=true&"
import script from "./Identite.vue?vue&type=script&lang=js&"
export * from "./Identite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddd69ac",
  null
  
)

export default component.exports